
const SettingsWrapper = ({
    title,
    subtitle,
    rightContent,
    onClick,
    children,
    buttonLabel,
}) => {
    
    return (
        
        <div className="SettingsWrapper w-full max-w-screen-lg h-full">
            
            <header className="flex justify-between items-center content-center p-4">
                
                <h3 className="block">
                    {title}
                    <br />
                    {subtitle && (<span className="text-sm">{subtitle}</span>)}
                </h3>
                
                {rightContent || null}
                
                {onClick && (
                    <button
                        onClick={onClick}
                        className="btn btn-sm btn-primary">
                        {buttonLabel}
                    </button>
                )}
            
            </header>
            
            <div className="p-4">
                {children}
            </div>
        
        </div>
        
    )
    
}

export default SettingsWrapper
